import React, { JSX } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Loader from '../components/ui/Loader';
import { RoleRouteProps } from '../types/routes.d';
import { LocalStorageUser } from '../types/localStorage.d';

const RoleRoute = ({ children, roles = [] }: RoleRouteProps): JSX.Element => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <Loader />
          <p className="mt-4 text-gray-600">Loading authentication...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const userRole: LocalStorageUser['role'] | '' = String(user?.role || '').toLowerCase() as LocalStorageUser['role'] | '';
  const allowed = roles.length === 0 ? true : roles.map((r) => String(r).toLowerCase()).includes(userRole);
  
  if (!allowed) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default RoleRoute;
